(function($, undefined) {
	'use strict';
	var utils;
	var cartUtils;
	var formValidator;
	var eventSignup;
	var paymentPopup;

	var cancelOrder = function() {
		cartUtils.clearCart(() => {}, true);
	};

	var showPayment = function() {
		paymentPopup.addClass('cart-payment-popup_payment');
		paymentPopup.find('.cart-payment-popup__payment').slideDown(function() {
			var scrollingCtn = paymentPopup.find('.stool-shared-popup-inner');
			var target = $(this).offset().top + scrollingCtn.scrollTop() - scrollingCtn.offset().top;

			scrollingCtn.animate({ scrollTop: target }, 'slow');
		});
	};

	var removeProduct = function() {
		var item = $(this).closest('.cart-payment-item');
		item.addClass('has-processing_active');

		if (item.attr('data-cart-id') === '0' && item.attr('data-event-id').length > 0) {
			eventSignup.removeParticipant(item.attr('data-event-id'), item.attr('data-firstname'), item.attr('data-lastname'));
		} else {
			cartUtils.removeFromCart(item,() => {}, true);
		}
	};

	var submitPaymentForm = function() {
		var btn = $(this);
		var form = btn.closest('.cart-payment-popup__form');
		var scrollingCtn = form.closest('.stool-shared-popup-inner');

		form.find('.payment-step:visible').each(function() {
			formValidator.validateForm($(this));
		});

		if (form.find('.payment-step.has-error').length === 0) {
			form.addClass('has-processing_active');
			form.find('.payment-step:hidden').remove();
			form.find('.select-state-input-ctn:not(.selected)').remove();

			analyticsBeforeSubmitCheckout(form);
		} else {
			var target = $('.payment-step.has-error').eq(0).offset().top  - 100 + scrollingCtn.scrollTop() - scrollingCtn.offset().top;
			scrollingCtn.animate({ scrollTop: target }, 500);
		}
	};

	var analyticsBeforeSubmitCheckout = function(form) {
		var json = {};
		json.m = form.attr('data-m');
		json.t = removePriceFormat($('.cart-payment-popup__amount-value.total').eq(0).text());
		json.p = [];

		form.find('.cart-payment-popup__items_recap .cart-payment-item').each(function() {
			var tr = $(this);

			json.p.push({
				n: encodeURIComponent(tr.find('.cart-payment-item__name .name').text()),
				p: removePriceFormat(tr.find('.cart-payment-item__price-value.price').text()),
				i: tr.attr('data-product-id') !== '0' ? tr.attr('data-product-id') : tr.attr('data-event-id'),
				c: tr.attr('data-category-id'),
				q: tr.find('.cart-payment-item__quantity.quantity').text().length > 0 ? parseInt(tr.find('.cart-payment-item__quantity.quantity').text()) : 1,
			});
		});
		
		document.cookie = "sendtoanalytics=" + JSON.stringify(json) + "; expires=Fri, 31 Dec 9999 23:59:59 GMT";

		form.submit();
	};

	var removePriceFormat = function(formattedPrice) {
		return formattedPrice.replace('$','').replace(',','.').trim();
	};

	var closePopup = function() {
		var btn = $(this);
		btn.closest('.stool-shared-popup').removeClass('visible');
	};

	var onPaymentTypeChange = function() {
		var input = $(this);
		var ctn = input.closest('.payment-step__section');
		var paymentInputsCtn = $('.payment-step__cc-inputs', ctn);

		if (input.val() == "card") {
			$('.required-if-cc', paymentInputsCtn).addClass('required').removeClass('required-if-cc');
			paymentInputsCtn.slideDown(300);
		} else {
			paymentInputsCtn.slideUp(300);
			$('.required', paymentInputsCtn).addClass('required-if-cc').removeClass('required');
		}
	};

	var onSameAddressChange = function(e) {
		var input = $(e.currentTarget);
		var ctn = input.closest('.payment-step__section-content');
		var target = $('.toggle-not-same-address', ctn);

		if (input.prop('checked')) {
            $('.required', target).addClass('derequired').removeClass('required');
			target.slideUp(300);
		} else {
            $('.derequired', target).addClass('required').removeClass('derequired');
			target.slideDown(300);
		}
	};

	var init = function() {
		utils = Fw.component.models().utils;
		cartUtils = Fw.component.models().cartUtils;
		formValidator = Fw.component.models().form;
		eventSignup = Fw.component.models().eventSignup;
		paymentPopup = $('.cart-payment-popup');

		$('.cart-payment-popup__cancel-order-btn').click(cancelOrder);
		$('.cart-payment-popup__show-payment-btn:not(.cart-payment-popup__show-payment-btn_not-logged)').click(showPayment);
		$('.cart-payment-item__remove-btn').click(removeProduct);
		$('.cart-payment-popup__confirm-payment-btn').click(submitPaymentForm);
		$('.cart-recap__quit-btn').click(closePopup);

		$('[name=paymentType]', paymentPopup).on('change', onPaymentTypeChange);
		$('[name=sameAddress]', paymentPopup).on('change', onSameAddressChange);
	};

	$(window).ready(init);
})(jQuery);